import React from 'react'
import { Link } from 'react-router-dom'
import { AppBar, Toolbar, Button, Box, Hidden } from '@mui/material'
import MapIcon from '@mui/icons-material/Map'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ShareMenu from '../../common/ShareButtons'
import CitySelector from 'components/nav/secondary/menu/CitySelector'

const TrendFilters = ({
  city,
  setCity,
  bedrooms,
  setBedrooms,
  olderData,
  setOlderData,
  onUpdate,
}) => {
  // Function to calculate the minSoldDate based on the selected years ago
  // const getMinSoldDate = (yearsAgo) => {
  //   const today = new Date()
  //   const pastDate = new Date(
  //     today.getFullYear() - yearsAgo,
  //     today.getMonth(),
  //     1
  //   ) // First day of that month
  //   return pastDate.toISOString().split('T')[0] // Format as YYYY-MM-DD
  // }

  // const handleSliderChange = (event, newValue) => {
  //   setOlderData(newValue)
  // }

  const handleUpdateClick = () => {
    onUpdate()
  }

  return (
    <AppBar className="secondaryAppBar" color="default">
      <Toolbar
        className="toolBar"
        style={{
          borderTop: `1px solid #E5E5E5`,
          minHeight: `54px`,
        }}
      >
        <Hidden mdDown>
          <Box>
            <Link to={`/list/${city}`}>
              <Button
                sx={{ marginTop: `0`, marginRight: `10px` }}
                component="button"
                color="primary"
                variant="contained"
                startIcon={<ArrowBackIcon />}
                className="primaryBtn"
              >
                View Listings
              </Button>
            </Link>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flexGrow: 1, display: 'flex' }}>
              {/* <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
              <TextField
                label="City"
                variant="outlined"
                size="small"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />

              <TextField
                label="Bedrooms"
                variant="outlined"
                size="small"
                type="number"
                value={bedrooms}
                onChange={(e) => setBedrooms(e.target.value)}
              />

              <div style={{ width: 200 }}>
                <Slider
                  value={olderData}
                  onChange={handleSliderChange}
                  step={null} // Prevents in-between values
                  marks={[
                    { value: 0, label: '0' },
                    { value: 2, label: '2Y' },
                    { value: 5, label: '5Y' },
                    { value: 10, label: '10Y' },
                    { value: 20, label: '20Y' },
                  ]}
                  min={0}
                  max={20}
                />
              </div>
              <Button
                variant="contained"
                sx={{ marginTop: `0` }}
                color="primary"
                onClick={handleUpdateClick}
              >
                Update
              </Button>
            </Box> */}
              <CitySelector
                city={city}
                setCity={setCity}
                onUpdate={handleUpdateClick}
              />
              <ShareMenu />
              <Link to={`/map/${city}`}>
                <Button
                  component="button"
                  color="primary"
                  variant="contained"
                  endIcon={<MapIcon />}
                  className="primaryBtn"
                  sx={{ marginTop: `0`, marginLeft: `20px` }}
                >
                  Map Search
                </Button>
              </Link>
            </Box>
          </Box>
        </Hidden>
        <Hidden mdUp>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flexGrow: 1, display: 'flex' }}>
              {/* <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
              <TextField
                label="City"
                variant="outlined"
                size="small"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />

              <TextField
                label="Bedrooms"
                variant="outlined"
                size="small"
                type="number"
                value={bedrooms}
                onChange={(e) => setBedrooms(e.target.value)}
              />

              <div style={{ width: 200 }}>
                <Slider
                  value={olderData}
                  onChange={handleSliderChange}
                  step={null} // Prevents in-between values
                  marks={[
                    { value: 0, label: '0' },
                    { value: 2, label: '2Y' },
                    { value: 5, label: '5Y' },
                    { value: 10, label: '10Y' },
                    { value: 20, label: '20Y' },
                  ]}
                  min={0}
                  max={20}
                />
              </div>
              <Button
                variant="contained"
                sx={{ marginTop: `0` }}
                color="primary"
                onClick={handleUpdateClick}
              >
                Update
              </Button>
            </Box> */}
              <CitySelector
                city={city}
                setCity={setCity}
                onUpdate={handleUpdateClick}
              />
              <ShareMenu />
              <Link to={`/map/${city}`}>
                <Button
                  component="button"
                  color="primary"
                  variant="contained"
                  className="primaryBtn"
                  sx={{ marginTop: `0`, marginLeft: `20px` }}
                >
                  <MapIcon />
                </Button>
              </Link>
            </Box>
          </Box>
          <Box>
            <Link to={`/list/${city}`}>
              <Button
                sx={{ marginTop: `0`, marginRight: `10px` }}
                component="button"
                color="primary"
                variant="contained"
                className="primaryBtn"
              >
                <ArrowBackIcon />
              </Button>
            </Link>
          </Box>
        </Hidden>
      </Toolbar>
    </AppBar>
  )
}

export default TrendFilters
